export const LABELS = {
  labelDeleteDialogTitle: 'Permanently delete label',
  labelDeleteDialogAriaLabel: 'Delete label?',
  cancelButtonText: 'Cancel',
  deleteButtonText: 'Delete',
  deleteLabelButtonText: 'Delete this label',
  deleteLabelWarningPermanent: 'Once you delete this label, you will not be able to see it again.',
  deleteLabelAssociatedIssuesNote: 'Deleting this label will remove it from all issues and pull requests.',
  deleteLabelError: 'There was an error deleting the label. Please try again.',
  searchAll: 'Search all labels',
  search: 'Search',
  newLabel: 'New label',
  labels: 'Labels',
  clearSearch: 'Clear search',
  noLabelsCreatedTitle: 'There are no labels in this repository',
  noLabelsCreatedDescription: 'Start creating labels using the "New Label" button.',
  noMatchingLabelsTitle: 'No matching labels',
  noMatchingLabelsDescription: 'We couldn’t find any labels that match your filter. Please try again.',
  nameRequired: 'Name is required',
  invalidColor: 'Color is invalid',
  editLabel: 'Edit label',
  name: 'Name',
  description: 'Description',
  color: 'Color',
  saveChanges: 'Save changes',
  editLabelError: 'Could not update label',
  createButtonText: 'Create label',
  updateLabelError: 'There was an error updating this label',
}
